<template>
  <sidenav :orientation="orientation" :class="curClasses">

    <!-- Inner -->
    <div class="sidenav-inner" :class="{ 'py-1': orientation !== 'horizontal' }">

      <sidenav-header class="small font-weight-semibold">TRAFFIC</sidenav-header>
      <sidenav-menu icon="ion ion-ios-log-in" :active="isMenuActive(generateUrl('/inbound'))" :open="isMenuOpen(generateUrl('/inbound'))">
        <template slot="link-text">Inbound</template>
        <sidenav-router-link :to="{ path: generateUrl('/inbound/ip-blocked') }"
                             :exact="true">IP Blocked</sidenav-router-link>
        <sidenav-router-link :to="{ path: generateUrl('/inbound/ip-archived') }"
                             :exact="true">IP Archived</sidenav-router-link>
        <sidenav-router-link :to="{ path: generateUrl('/inbound/ip-pro-blocked') }"
                             :exact="true">IP Pro Blocked</sidenav-router-link>
        <sidenav-router-link :to="{ path: generateUrl('/inbound/ip-pro-archived') }"
                             :exact="true">IP Pro Archived</sidenav-router-link>
<!--        <sidenav-router-link :to="{ path: '/blank' }"-->
<!--                             :exact="false" event="" disabled>IP Archived</sidenav-router-link>-->
        <sidenav-router-link :to="{ path: generateUrl('/inbound/ip-whitelisting') }"
                             :exact="true">IP Whitelisting</sidenav-router-link>
      </sidenav-menu>

      <sidenav-menu icon="ion ion-ios-log-out"
                    :active="isMenuActive(generateUrl('/outbound'))"
                    :open="isMenuOpen(generateUrl('/outbound'))"
                    v-if="$route.params.customer"
      >
        <template slot="link-text">Outbound</template>
        <sidenav-router-link :to="{ path: generateUrl('/outbound/ip-blocked') }"
                             :exact="true">IP Blocked</sidenav-router-link>
        <sidenav-router-link :to="{ path: generateUrl('/outbound/ip-archived') }"
                             :exact="true">IP Archived</sidenav-router-link>
        <sidenav-router-link :to="{ path: generateUrl('/outbound/ip-whitelisting') }"
                             :exact="true">IP Whitelisting</sidenav-router-link>
        <sidenav-divider class="mb-1"/>
        <sidenav-router-link :to="{ path: generateUrl('/outbound/url-blocked') }"
                             :exact="true">URL Blocked</sidenav-router-link>
        <sidenav-router-link :to="{ path: generateUrl('/outbound/url-archived') }"
                             :exact="true">URL Archived</sidenav-router-link>
        <sidenav-router-link :to="{ path: generateUrl('/outbound/url-whitelisting') }"
                             :exact="true">URL Whitelisting</sidenav-router-link>
        <sidenav-divider class="mb-1"/>
        <sidenav-router-link :to="{ path: generateUrl('/outbound/domain-blocked') }"
                             :exact="true">Domain Blocked</sidenav-router-link>
        <sidenav-router-link :to="{ path: generateUrl('/outbound/domain-archived') }"
                             :exact="true">Domain Archived</sidenav-router-link>
        <sidenav-router-link :to="{ path: generateUrl('/outbound/domain-whitelisting') }"
                             :exact="true">Domain Whitelisting</sidenav-router-link>
      </sidenav-menu>

      <sidenav-divider class="mb-1"/>

      <sidenav-header class="small font-weight-semibold">SETTINGS</sidenav-header>
      <sidenav-menu icon="ion ion-md-code-working" :active="isMenuActive(generateUrl('/field-registration'))" :open="isMenuOpen(generateUrl('/field-registration'))">
        <template slot="link-text">Field Registration</template>
        <sidenav-router-link :to="{ path: generateUrl('/field-registration/inbound-ip') }"
                             :exact="true">Inbound IP</sidenav-router-link>
        <sidenav-router-link :to="{ path: generateUrl('/field-registration/outbound-ip') }"
                             :exact="true"
                             v-if="$route.params.customer">Outbound IP</sidenav-router-link>
        <sidenav-router-link :to="{ path: generateUrl('/field-registration/outbound-url') }"
                             :exact="true"
                             v-if="$route.params.customer">URL</sidenav-router-link>
        <sidenav-router-link :to="{ path: generateUrl('/field-registration/outbound-domain') }"
                             :exact="true"
                             v-if="$route.params.customer">Domain</sidenav-router-link>
      </sidenav-menu>

      <sidenav-router-link icon="ion ion-md-timer"
                           :to="{ path: generateUrl('/retention-condition') }"
                           :exact="true">Retention Condition</sidenav-router-link>
      <sidenav-router-link icon="ion ion-md-checkmark-circle-outline"
                           :to="{ path: generateUrl('/blocklist-condition') }"
                           :exact="true"
                           v-if="$route.params.customer">Blocklist Condition</sidenav-router-link>
      <sidenav-router-link icon="ion ion-ios-contract"
                           :to="{ path: generateUrl('/proactive-condition') }"
                           :exact="true"
                           v-if="$route.params.customer">Proactive Condition</sidenav-router-link>
      <sidenav-router-link icon="ion ion-md-eye"
                           :to="{ path: generateUrl('/ti-lookup') }"
                           :exact="true"
                           v-if="$route.params.customer">TI Lookup</sidenav-router-link>
<!--      <sidenav-router-link icon="ion ion-md-list-box"-->
<!--                           :to="{ path: generateUrl('/reporting') }"-->
<!--                           :exact="true"-->
<!--                           v-if="$route.params.customer">Reporting</sidenav-router-link>-->
      <sidenav-router-link icon="ion ion-md-list-box"
                           :to="{ path: generateUrl('/report-scheduler') }"
                           :exact="true"
                           v-if="$route.params.customer">Report Scheduler</sidenav-router-link>

    </div>
  </sidenav>
</template>

<script>
import { Sidenav, SidenavLink, SidenavRouterLink, SidenavMenu, SidenavHeader, SidenavBlock, SidenavDivider } from '@/vendor/libs/sidenav'

export default {
  name: 'app-layout-sidenav',
  components: {
    /* eslint-disable vue/no-unused-components */
    Sidenav,
    SidenavLink,
    SidenavRouterLink,
    SidenavMenu,
    SidenavHeader,
    SidenavBlock,
    SidenavDivider
    /* eslint-enable vue/no-unused-components */
  },

  props: {
    orientation: {
      type: String,
      default: 'vertical'
    }
  },

  computed: {
    curClasses () {
      let bg = this.layoutSidenavBg

      if (this.orientation === 'horizontal' && (bg.indexOf(' sidenav-dark') !== -1 || bg.indexOf(' sidenav-light') !== -1)) {
        bg = bg
          .replace(' sidenav-dark', '')
          .replace(' sidenav-light', '')
          .replace('-darker', '')
          .replace('-dark', '')
      }

      return `bg-${bg} ` + (
        this.orientation !== 'horizontal'
          ? 'layout-sidenav'
          : 'layout-sidenav-horizontal container-p-x flex-grow-0'
      )
    }
  },

  methods: {
    isMenuActive (url) {
      return this.$route.path.indexOf(url) === 0
    },

    isMenuOpen (url) {
      return this.$route.path.indexOf(url) === 0 && this.orientation !== 'horizontal'
    },

    toggleSidenav () {
      this.layoutHelpers.toggleCollapsed()
    },

    generateUrl (uri) {
      return ('/' + (this.$route.params.customer || '') + uri).replace('//', '/')
    }
  }
}
</script>
